import { Injectable } from "@angular/core";
import { ApplicationSettings } from "app/models/applicationSettings";

import { Observable } from "rxjs";
import { HttpBackendService } from "./http-backend.service";

@Injectable()
export class ApplicationSettingsService {

    constructor(
        private _http: HttpBackendService
    ) {}

    get applicationSettings() : Observable<ApplicationSettings> {
        return this._http.get("/api/applicationSettings")
            .map(resp => {
                return ApplicationSettingsService.convertApplicationSettingsDTO2Object(resp.json());
            });
    }
}


export namespace ApplicationSettingsService {
    export function convertApplicationSettingsDTO2Object(dto : any, applicationSettings = new ApplicationSettings()) : ApplicationSettings {
        if (dto.Banner && dto.Banner.Title || dto.Banner.Title !== ""  && dto.Banner.Content || dto.Banner.Content !== "")
        {
            applicationSettings.banner.title = dto.Banner.Title;
            applicationSettings.banner.content = dto.Banner.Content;
        }

        return applicationSettings;
    }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/applicationSettings.service.ts